var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multi-selectbox',{attrs:{"options":_vm.options,"multiple":false},on:{"input":_vm.handleInput},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),(_vm.validateError)?_c('span',{staticClass:"invalid-feedback-custom",domProps:{"innerHTML":_vm._s(_vm.validateError)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }